import React, {Fragment} from 'react'
import {Nullable} from '../../../../Common/TypeHelper'
import {Spacer} from '../../../../Common/Components/Spacer'

type Props = {
  errors: string[]
  newLineByBr?: boolean
  style?: Record<string, unknown>
}

export function ErrorDisplay(props: Props): Nullable<JSX.Element> {
  if (props.errors.length === 0) {
    return null
  }

  if (props.newLineByBr) {
    return (
      <Spacer mt={'10px'}>
      <span className="form-error-text" style={props.style}>
      {props.errors.map((error, i, array) => {
        if (array.length - 1 === i) {
          return <Fragment key={i}>{error}</Fragment>
        }
        return <Fragment key={i}>{error}<br/></Fragment>
      })}
      </span>
      </Spacer>
    )
  }

  return <Spacer mt={'10px'}>
    {props.errors.map((error, i) => (
      <span key={i} className="form-error-text" style={props.style}>
        {error}
      </span>
    ))}
  </Spacer>
}
